/**
 * Accounts included in the morning daily-summary push.
 * Keys are `${AccountID}:live` or `${AccountID}:paper` so the same broker id
 * can be selected on SIM and live independently. The server uses the same shape.
 */

import { findStarredAccount } from './starredAccount';

export function rundownAccountKey(account) {
  if (account?.AccountID == null || account.AccountID === '') return null;
  return `${account.AccountID}:${account.isPaperTrading ? 'paper' : 'live'}`;
}

/**
 * Account checked by default before the user picks summary accounts.
 * Starred account wins, then the last account used, then the first live account.
 */
export function defaultRundownAccount(accounts, appSettings) {
  const list = Array.isArray(accounts) ? accounts : [];
  if (list.length === 0) return null;
  const starred = findStarredAccount(list, appSettings);
  if (starred) return starred;
  const selectedId = appSettings?.selectedAccountId;
  if (selectedId != null && selectedId !== '') {
    const selected = list.find((account) => String(account?.AccountID) === String(selectedId));
    if (selected) return selected;
  }
  return list.find((account) => !account?.isPaperTrading) || list[0];
}

/** Saved keys that still match a connected account. Null when the user has never chosen. */
export function savedRundownAccountKeys(appSettings) {
  const saved = appSettings?.pushNotifications?.rundownAccountKeys;
  return Array.isArray(saved) ? saved.map((key) => String(key)) : null;
}
